import { render } from "./CanvasBox.vue?vue&type=template&id=74cb39ba&scoped=true&ts=true"
import script from "./CanvasBox.vue?vue&type=script&lang=ts"
export * from "./CanvasBox.vue?vue&type=script&lang=ts"

import "./CanvasBox.vue?vue&type=style&index=0&id=74cb39ba&lang=scss&scoped=true"

import exportComponent from "/Users/wangyong/shanggeyun/code/sagacloud-sagacare-ipad/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74cb39ba"]])

export default __exports__